/**
 * @generated SignedSource<<a53db9dea4b3cd6bbecaf42ffd2eaee2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccasionSelector_routineOccasion$data = {
  readonly startAt: string;
  readonly " $fragmentType": "OccasionSelector_routineOccasion";
};
export type OccasionSelector_routineOccasion$key = {
  readonly " $data"?: OccasionSelector_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccasionSelector_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccasionSelector_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "01e9dba2093ccfa86be0fc3efb428279";

export default node;
